<div class="tree-node" (click)="selectGroup()">
    <div class="set-title">
      <button mat-icon-button>
        <mat-icon svgIcon="folder-wrench"></mat-icon>
      </button>
      <span class="name">
        {{ node.label }}
      </span>
    </div>
  </div>

  <div class="sub-nodes">
    <restoreid-group-tree-node *ngFor="let subNode of childNodes" [node]="subNode"></restoreid-group-tree-node>
  </div>
